import React, { useState, useEffect } from "react";
import { Accordion, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
	getBillingByPatient,
	getBillingByStaffId,
} from "../../../apis/billing";
import { getDepartments } from "../../../apis/departments";
import { getMembershipCategories } from "../../../apis/membership";
import {
	getNurseNotes,
	getPatientNotes,
	updateNote,
} from "../../../apis/notes";
import { getPatients } from "../../../apis/patients";
import { getStaffByDepartment } from "../../../apis/staff";
import { toastify } from "../../../helperFunctions/toastify";
import DeleteModal from "../../SharedComponents/DeleteModal";
import SelectComponent from "../../SharedComponents/SelectComponent";
import NoteRenderer from "./NoteRenderer";
import { DOCTOR_DEPARTMENT_ID, NURSE_DEPARTMENT_ID } from "../../../constants";
import TabNurseNotes from "../Patient/TabNurseNotes";
import TabNutrionNotes from "../Patient/TabNutrionNotes";

function PatientNotesSelected(props) {
	const [notes, setNotes] = useState([]);
	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");
	const [selectedPatient, setSelectedPatient] = useState();
	// const { state } = useLocation();
	const userData = useSelector((state) => state.userData.value);

	const [usePointVal, setUsePointVal] = useState(0);
	// const patientData = useSelector((state) => state.patientData.value);
	const [patientData, setPatientData] = useState();
	const [options, setOptions] = useState([]);
	const [selectedOption, setSelectedOption] = useState("");
	const navigate = useNavigate();

	const getPatientNotesList = async (id) => {
		let typeNote = "";
		if (props?.selectedRole == "THERAPIST") {
			typeNote = "Therapist";
		}
		if (props?.selectedRole == "NUTRITIONIST") {
			typeNote = "Nutritionist";
		}

		const response = await getPatientNotes(id, typeNote);
		if (response.status !== "Fail") {
			setNotes(response);
		} else if (response?.message === "No data Found") {
			setNotes([]);
		} else {
			toastify(response?.message, "error");
		}
	};

	// const getNurseNotesList = async (id) => {
	// 	const response = await getNurseNotes(id);
	// 	if (response.status !== "Fail") {
	// 		setNotes(response);
	// 	} else if (response?.message === "No data Found") {
	// 		setNotes([]);
	// 	} else {
	// 		toastify(response?.message, "error");
	// 	}
	// };
	// let response = await getPatientDetailsById(patientData?._id);
	//   if (response?.status !== "Fail") {
	//     setNotes(
	//       response?.nurseNotesList?.reverse()?.filter((e) => !e.isDeleted)
	//     );
	//   } else {
	//     toastify(response?.message, "error");
	//   }

	useEffect(() => {
		// getNotesList();
	}, []);

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};
	const getPatientsDetails = async (id) => {
		const { result, error } = await getBillingByPatient(id);
		if (error) {
			toastify(error.message, "error");
			return;
		}

		const tempArr = result
			?.filter((o) => o.session)
			?.map((e) => {
				const historyObj = {
					medicalHistory:
						e?.session?.patientMedicalHistory?.pastMedicalHistory,
					cosmeticHistory:
						e?.session?.patientMedicalHistory?.pastCosmeticHistory,
					adverseCosmeticHistory:
						e?.session?.patientMedicalHistory
							?.pastAdverseCosmeticHistory,
					socialHistory:
						e?.session?.patientMedicalHistory?.socialHistory,
				};
				const loc = e?.branch?.location?.find(
					(o) => o._id === e?.location,
				);

				const packages = e?.package?.map((o) => {
					return {
						name: o?.package_id?.name,
						qty: o?.package_qty,
						price: o?.package_unit_price * o?.package_qty,
						discount: o?.package_discount,
						total_price: o?.package_price,
					};
				});

				const product = e?.product?.map((o) => {
					return {
						name: o?.product_id?.name,
						qty: o?.product_qty,
						price: o?.product_unit_price * o?.product_qty,
						discount: o?.product_discount,
						total_price: o?.product_price,
					};
				});
				const treatment = e?.treatment?.map((o) => {
					return {
						name: o?.service_id?.name,
						qty: o?.service_qty,
						price: o?.service_unit_price * o?.service_qty,
						discount: o?.service_discount,
						total_price: o?.service_price,
					};
				});

				const others = e?.others?.map((o) => {
					return {
						name: o?.description,
						qty: 1,
						price: o?.total_price,
						discount: 0,
						total_price: o?.total_price,
					};
				});
				const taxVal =
					e?.tax?.typeValue == "Percentage"
						? (e.tax?.value / 100) * e?.actualAmount
						: e?.tax?.value;
				const notesObj = {
					startTime: e?.session?.startTime,
					endTime: e?.session?.endTime,
					staff: e?.session?.staff?.map((o) => o?.username),
					soap: e?.session?.patientSOAP,
					location: loc,
					service: [...packages, ...product, ...treatment, ...others],
					remarks: e?.remarks,
					usePoints: e?.usePoints,
					promo: e?.promo,
					tax: e?.tax,
					promoDiscount: (e?.promo / 100) * e?.actualAmount,
					afterTaxValue: taxVal,
					actualAmount: e?.actualAmount,
					totalAmount: e?.totalAmount,
				};
				return {
					date: new Date(e.created_at).toLocaleDateString(),
					history: historyObj,
					notes: notesObj,
					// sessionId: e?.session?._id,
				};
			});

		setPatientData([...tempArr]);
	};
	// const getDoctorNotesDetails = async (id) => {
	// 	const { result, error } = await getBillingByStaffId(id);
	// 	if (error) {
	// 		toastify(error?.message ?? "Failed to get doctor notes", "error");
	// 		return;
	// 	}
	// 	const tempArr = result?.data?.map((e) => {
	// 		const historyObj = {
	// 			medicalHistory:
	// 				e?.session?.patientMedicalHistory?.pastMedicalHistory,
	// 			cosmeticHistory:
	// 				e?.session?.patientMedicalHistory?.pastCosmeticHistory,
	// 			adverseCosmeticHistory:
	// 				e?.session?.patientMedicalHistory
	// 					?.pastAdverseCosmeticHistory,
	// 			socialHistory: e?.session?.patientMedicalHistory?.socialHistory,
	// 		};
	// 		const loc = e?.branch?.location?.find((o) => o._id === e?.location);

	// 		const packages = e?.package?.map((o) => {
	// 			return {
	// 				name: o?.package_id?.name,
	// 				qty: o?.package_qty,
	// 				price: o?.package_unit_price * o?.package_qty,
	// 				discount: o?.package_discount,
	// 				total_price: o?.package_price,
	// 			};
	// 		});
	// 		const product = e?.product?.map((o) => {
	// 			return {
	// 				name: o?.product_id?.name,
	// 				qty: o?.product_qty,
	// 				price: o?.product_id?.unitSellingPrice * o?.product_qty,
	// 				discount: o?.product_discount,
	// 				total_price:
	// 					o?.product_id?.unitSellingPrice * o?.product_qty -
	// 					o?.product_discount,
	// 			};
	// 		});
	// 		const treatment = e?.treatment?.map((o) => {
	// 			return {
	// 				name: o?.service_id?.name,
	// 				qty: o?.service_qty,
	// 				price: o?.service_unit_price * o?.service_qty,
	// 				discount: o?.service_discount,
	// 				total_price: o?.service_price,
	// 			};
	// 		});
	// 		const taxVal =
	// 			e?.tax?.typeValue == "Percentage"
	// 				? (e.tax?.value / 100) * e?.actualAmount
	// 				: e?.tax?.value;
	// 		const notesObj = {
	// 			startTime: e?.session?.startTime,
	// 			endTime: e?.session?.endTime,
	// 			staff: e?.session?.staff?.map((o) => o?.username),
	// 			soap: e?.session?.patientSOAP,
	// 			location: loc,
	// 			service: [...packages, ...product, ...treatment],
	// 			remarks: e?.remarks,
	// 			usePoints: e?.usePoints,
	// 			promo: e?.promo,
	// 			tax: e?.tax,
	// 			promoDiscount: (e?.promo / 100) * e?.actualAmount,
	// 			afterTaxValue: taxVal,
	// 			actualAmount: e?.actualAmount,
	// 			totalAmount: e?.totalAmount,
	// 		};
	// 		return {
	// 			date: new Date(e.created_at).toLocaleDateString(),
	// 			history: historyObj,
	// 			notes: notesObj,
	// 			// sessionId: e?.session?._id,
	// 		};
	// 	});

	// 	setPatientData([...tempArr]);
	// };
	const callDesiredAPI = (val) => {
		setSelectedOption(val);
		if (props?.selectedRole == "PATIENT" && val) {
			getPatientsDetails(val);
			getPatientNotesList(val);
		} else if (props?.selectedRole == "DOCTOR") {
			getPatientsDetails(val);

			// getDoctorNotesDetails(val);
		} else if (props?.selectedRole == "THERAPIST") {
			getPatientNotesList(val);

			// getNurseNotesList(val);
		} else if (props?.selectedRole == "NUTRITIONIST") {
			getPatientNotesList(val);
		}
	};
	const checkDate = (noteDate) => {
		let day1 = new Date().getDate();
		let day2 = new Date(noteDate).getDate();

		let month1 = new Date().getMonth();
		let month2 = new Date(noteDate).getMonth();

		let year1 = new Date().getFullYear();
		let year2 = new Date(noteDate).getFullYear();

		if (day1 === day2 && month1 === month2 && year1 === year2) return true;
		else return false;
	};

	const removeNote = async () => {
		let isSameDay = false;

		let ind = notes.find((e) => {
			if (deleting === e._id) {
				if (checkDate(e.created_at)) isSameDay = true;
				return e;
			}
		});

		setShow(false);

		if (ind?.staff?._id === userData._id) {
			if (isSameDay) {
				const response = await updateNote(deleting, {
					isDeleted: true,
				});

				if (response?.status !== "Fail") {
					toastify("Note deleted successfully!", "success");
					// getPatientNotes(selectedOption);
					getPatientNotesList(selectedOption);
				} else {
					toastify(response?.message, "error");
				}
			} else {
				toastify("Note can be deleted on the same day only.", "error");
			}
		} else {
			toastify("Only note maker can update/delete note.", "error");
		}
	};
	const onNoteSave = async (e, id, callback) => {
		if (!e) {
			toastify("Notes is missing", "error");
			return;
		}
		let response = await updateNote(id, { description: e });
		if (response?.status !== "Fail") {
			toastify("Note updated successfully!", "success");
			getPatientNotesList(selectedPatient);

			callback(true);
		} else {
			toastify(response?.message);
			callback(false);
		}
	};
	useEffect(() => {
		setOptions([]);
		setNotes([]);
		setPatientData([]);
		setSelectedOption(null);
		// if (props?.selectedRole == "PATIENT") {
		(async () => {
			const response = await getPatients();
			if (response.status !== "Fail") {
				const tempArr = response.map((o) => {
					return {
						value: o._id,
						label: o.patientProfile?.fullName,
					};
				});
				setOptions(tempArr);
			} else {
				if (response?.message === "No data Found") {
					setOptions([]);
				} else {
					toastify(response?.message, "error");
				}
			}
		})();
		// } else {
		// 	(async () => {
		// 		const departID =
		// 			props?.selectedRole == "DOCTOR"
		// 				? DOCTOR_DEPARTMENT_ID
		// 				: NURSE_DEPARTMENT_ID;
		// 		const response = await getStaffByDepartment(departID);
		// 		if (response.status !== "Fail") {
		// 			const tempArr = response.map((o) => ({
		// 				value: o._id,
		// 				label: o?.username,
		// 			}));
		// 			setOptions([...tempArr]);
		// 			// setStaff(response);
		// 		} else {
		// 			toastify(response.message, "error");
		// 		}
		// 	})();
		// }
	}, [props.selectedRole]);
	useEffect(() => {
		(async () => {
			const res = await getMembershipCategories();
			if (res?.status !== "Fail") {
				setUsePointVal(0);
				return;
			}
			setUsePointVal(res?.point);
		})();
	}, []);
	return (
		<div>
			<div className="mainHeading mx-4">
				<h1>
					<i
						className="fa fa-arrow-left cursor-pointer"
						onClick={() => navigate(-1)}
					></i>
					Note
				</h1>
			</div>
			<Form.Group className="col-4 mx-4">
				<Form.Label className="font-400-20 grey">
					<b>
						Select Patient
						{/* {props?.selectedRole[0]?.toUpperCase() +
							props?.selectedRole?.slice(1)?.toLowerCase()} */}
					</b>
				</Form.Label>
				<SelectComponent
					singleSelect
					searchEnabled
					options={options}
					selectedValue={selectedOption}
					onChange={(e) => {
						setPatientData([]);
						setNotes([]);
						setSelectedPatient(e.value);
						callDesiredAPI(e.value);
					}}
				/>
			</Form.Group>
			{selectedOption && (
				<>
					<div className="d-flex">
						{props?.selectedRole === "DOCTOR" && (
							<>
								<div className=" col-md-4 me-4">
									<div className="bold patient-history white-background mt-0 py-2 px-4">
										Patient History
									</div>
									<div className="mb-3 white-background px-1">
										<div className="history mt-0 py-2">
											Medical History
										</div>

										{patientData?.length > 0 &&
											patientData?.map((e, i) => {
												if (
													!e.history?.medicalHistory
												) {
													return <></>;
												}
												return (
													<>
														<Accordion>
															<Accordion.Item
																eventKey="0"
																style={{
																	border: "none",
																	outline:
																		"none",
																}}
															>
																<Accordion.Header>
																	<div className="bold font-14">
																		{e.date}
																	</div>
																</Accordion.Header>
																<Accordion.Body>
																	<div>
																		<div>
																			<div>
																				{
																					e
																						.history
																						?.medicalHistory
																				}
																			</div>
																		</div>
																	</div>
																</Accordion.Body>
															</Accordion.Item>
														</Accordion>
													</>
												);
											})}
									</div>
									<div className="mb-3 white-background px-1">
										<div className="history py-2">
											Cosmetic History
										</div>

										{patientData?.length > 0 &&
											patientData?.map((e, i) => {
												if (
													!e.history?.cosmeticHistory
												) {
													return <></>;
												}
												return (
													<>
														<Accordion>
															<Accordion.Item
																eventKey="0"
																style={{
																	border: "none",
																	outline:
																		"none",
																}}
															>
																<Accordion.Header>
																	<div className="bold font-14">
																		{e.date}
																	</div>
																</Accordion.Header>
																<Accordion.Body>
																	<div>
																		<div>
																			<div>
																				{
																					e
																						.history
																						?.cosmeticHistory
																				}
																			</div>
																		</div>
																	</div>
																</Accordion.Body>
															</Accordion.Item>
														</Accordion>
													</>
												);
											})}
									</div>
									<div className="mb-3 white-background px-1">
										<div className="history py-2">
											Adverse Cosmetic History
										</div>

										{patientData?.length > 0 &&
											patientData?.map((e, i) => {
												if (
													!e.history
														?.adverseCosmeticHistory
												) {
													return <></>;
												}
												return (
													<>
														<Accordion>
															<Accordion.Item
																eventKey="0"
																style={{
																	border: "none",
																	outline:
																		"none",
																}}
															>
																<Accordion.Header>
																	<div className="bold font-14">
																		{e.date}
																	</div>
																</Accordion.Header>
																<Accordion.Body>
																	<div>
																		<div>
																			<div>
																				{
																					e
																						.history
																						?.adverseCosmeticHistory
																				}
																			</div>
																		</div>
																	</div>
																</Accordion.Body>
															</Accordion.Item>
														</Accordion>
													</>
												);
											})}
									</div>
									<div className="mb-3 white-background px-1">
										<div className="history py-2">
											Social History
										</div>

										{patientData?.length > 0 &&
											patientData?.map((e, i) => {
												if (!e.history?.socialHistory) {
													return <></>;
												}
												return (
													<>
														<Accordion>
															<Accordion.Item
																eventKey="0"
																style={{
																	border: "none",
																	outline:
																		"none",
																}}
															>
																<Accordion.Header>
																	<div className="bold font-14">
																		{e.date}
																	</div>
																</Accordion.Header>
																<Accordion.Body>
																	<div>
																		<div>
																			<div>
																				{
																					e
																						.history
																						?.socialHistory
																				}
																			</div>
																		</div>
																	</div>
																</Accordion.Body>
															</Accordion.Item>
														</Accordion>
													</>
												);
											})}
									</div>
								</div>
							</>
						)}
						<div
							className={`white-background p-3 ${
								props?.selectedRole === "DOCTOR"
									? "col-md-7"
									: "w-100"
							}`}
						>
							{/* <div className="font-400-20 mb-3">
						<b>{state?.name ?? ""}</b>
					</div> */}
							{props?.selectedRole === "DOCTOR" &&
								patientData?.length > 0 &&
								patientData?.map((o) => {
									return (
										<>
											<div className="mb-3">
												<NoteRenderer
													role={"Doctor"}
													notes_data={o.notes}
													date={o.date}
													pointVal={usePointVal}
												/>
											</div>
										</>
									);
								})}
							{props?.selectedRole == "THERAPIST" && (
								<>
									<TabNurseNotes
										patientId={selectedPatient}
									/>
								</>
							)}
							{props?.selectedRole == "NUTRITIONIST" && (
								<>
									<TabNutrionNotes
										patientId={selectedPatient}
									/>
								</>
							)}
							{/* {props?.selectedRole === "THERAPIST" &&
								notes?.map((e) => (
									<NoteRenderer
										note={e}
										role={"Nurse"}
										userId={userData._id}
										handleClose={handleClose}
										show={show}
										setShow={setShow}
										setDeleting={setDeleting}
										editable
										onNoteSave={onNoteSave}
										// editNote={editNote}
									/>
								))} */}
							<DeleteModal
								content="Confirm Patient Note Deletion?"
								onYes={removeNote}
								onNo={handleClose}
								show={show}
							/>
						</div>
					</div>
				</>
			)}
		</div>
	);
}

export default PatientNotesSelected;
